import React from "react";

import { useTableKeyboardNavigation } from "@progress/kendo-react-data-tools";
import {
  // eslint-disable-next-line no-unused-vars
  GridCellProps,
  GRID_COL_INDEX_ATTRIBUTE,
} from "@progress/kendo-react-grid";
import { formatDate } from "@telerik/kendo-intl";
import { DatePicker } from "@progress/kendo-react-dateinputs";

export default function GridDateTimeCell(props) {
  const value = props.dataItem[props.field];
  const navigationAttributes = useTableKeyboardNavigation(props.id);
  var date;
  if (value === null || value === undefined || value === "") {
    date = "";
  } else {
    date = formatDate(new Date(value), "dd/MM/yyyy HH:mm:ss");
  }
  const handleChange = (e) => {
    if (props.onChange) {
      props.onChange({
        dataIndex: props.dataIndex,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value,
      });
    }
  };
  return (
    <td
      title={value}
      aria-selected={props.isSelected}
      colSpan={props.colSpan}
      aria-colindex={props.ariaColumnIndex}
      {...{ [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex }}
      {...navigationAttributes}
    >
      {props.edit ? (
        <DatePicker value={value} name={props.field} onChange={handleChange} />
      ) : (
        date || "-"
      )}
    </td>
  );
}
